import { ApiService, HttpMethod } from '@app/api/_common/api.service';
import { ActivityReport } from '@app/api/activity-report/models/activity-report.models';
import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ActivityReportApiService extends ApiService {
    // =========================================================================================================================================================
    // Public Methods
    // =========================================================================================================================================================

    getActivityReport(accountId: string, startDate: string, endDate: string, limit: number = 20, cursor: string | null = null): Observable<ActivityReport> {
        return this.apiRequest<any>(this.getActivityReportUrl(accountId, startDate, endDate, limit, cursor), HttpMethod.Get)
            .pipe(map((result: any) => new ActivityReport(result)));
    }

    /** Latest activities for an account (no date filter — same source as the activity monitor toolbar). */
    getRecentActivities(accountId: string, limit: number = 50): Observable<ActivityReport> {
        return this.apiRequest<any>(this.getRecentActivitiesUrl(accountId, limit), HttpMethod.Get)
            .pipe(map((result: any) => new ActivityReport(result)));
    }

    // =========================================================================================================================================================
    // URLs
    // =========================================================================================================================================================

    public get baseApiUrl(): string {
        return `${environment.accountApiUrl}/api/Reports/accounts`;
    }

    private getActivityReportUrl(accountId: string, startDate: string, endDate: string, limit: number,
        cursor: string | null): string {
        return `${this.baseApiUrl}/${accountId}/activityReport${this.buildQueryParams({ startDate, endDate, limit, cursor })}`;
    }

    private getRecentActivitiesUrl(accountId: string, limit: number): string {
        return `${environment.accountApiUrl}/api/ActivityMonitor/accounts/${accountId}/activities${this.buildQueryParams({ limit })}`;
    }
}
